module.exports = __webpack_public_path__ + "img/create.d6ba9d09.svg";